<template>
  <el-dialog title="栏目信息" :visible.sync="dialogFormVisible" custom-class="max-dialog" center :append-to-body="true"
             :close-on-click-modal="false" @close="closeDialog"
  >
    <el-form :model="form" ref="form1">
      <el-row>
        <el-col :span="4">
          <div class="grid-content bg-purple treeContent" style="height: 500px !important;overflow:hidden">
            <CommonTreeView
              ref="treeDserial" :defineDataSource="true" @bindData="bindData" :defaultexpandedkeys="defaultexpandedkeys"
              :onlyShowGroupType="true"
              @check="checktree1" :title="title1"
              :needTopNode="false">
            </CommonTreeView>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple-light">
            <!--<div>-->
            <div class="search-content">
              <el-col :span="24" class="toobar">
                <span class="demonstration">开始日期</span>
                <el-date-picker style="width:150px"
                                v-model="beginDate" :value-format="'yyyy-MM-dd'"
                                type="date"
                                placeholder="选择日期">
                </el-date-picker>
                <span class="demonstration">结束日期</span>
                <el-date-picker style="width:150px"
                                v-model="endDate" :value-format="'yyyy-MM-dd'"
                                type="date"
                                placeholder="选择日期">
                </el-date-picker>

                <el-input style="width:200px;"
                          placeholder="请输入标题"
                          prefix-icon="el-icon-search"
                          v-model="searchdata">
                </el-input>

                <el-button type="primary" icon="el-icon-search" @click="bindGrid">搜索</el-button>
                <el-button type="warning" v-on:click="addInfor">新增</el-button>
                <InforEdit ref="InforEdit" @bindInfoList="bindGrid"></InforEdit>
              </el-col>
            </div>

            <el-table
              :data="tableData"
              :height="tableHeight(220)"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                width="60"
                label="序号"
                align="center">
                <template slot-scope="scope">
                  {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
                </template>
              </el-table-column>

              <el-table-column
                prop="title"
                label="标题"
                align="left"
                header-align="center">
                <template slot-scope="scope">
                  <div @click="lookDetails(scope.$index, scope.row)" style="cursor: pointer">{{scope.row.title}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="uname"
                label="发布者"
                align="center" width="120"
                header-align="center"
              >
              </el-table-column>
              <el-table-column
                prop="dname"
                label="部门"
                align="left" width="150"
                header-align="center"
              >
              </el-table-column>
              <el-table-column
                align="center"
                label="日期" width="150">
                <template slot-scope="scope">
                  {{(scope.row.startdate || "").substr(0, 10)}}
                </template>
              </el-table-column>
              <!--<el-table-column-->
                <!--prop="visittimes"-->
                <!--label="访问次数"-->
                <!--align="center"-->
                <!--header-align="center"-->
                <!--width="200"-->
              <!--&gt;-->
              <!--</el-table-column>-->


              <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="lookDetails(scope.$index, scope.row)">查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <InforDetail ref="InforDetail" @bindInfoList="bindGrid"></InforDetail>
            <div class="foot">
              <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>
<script>
  import {getClassTree} from '@/api/oa/inforclass'
  import {getListData, getDetail} from '@/api/oa/inforlist';
  import InforDetail from '../inforlist/InforDetail';
  import InforEdit from '../inforlist/InforEdit';

  export default {
    name: 'InforclassList',
    data() {
      return {
        title1: "",
        seen: false,
        dialogFormVisible: false,
        defaultexpandedkeys: [],
        searchdata: "",
        classcode: '',
        classname:'',
        beginDate: '',
        endDate: '',
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        form: {},
        tableData: []
      }
    },
    methods: {
      closeDialog(){
        this.title1=''
      },
      lookDetails(index, row) {
        this.$refs.InforDetail.initData(row.unitguid);
      },
      checktree1(guids, names, arr) {
        //控制增加按钮的动态显示
        this.classcode = guids;
        this.classname=names;
        this.bindGrid();
      },
      bindData() {
        this.$refs.treeDserial.bindData(() => {
          return getClassTree({onlyShowGroupType: true, onlyShowEnabledGroupType: true, cyzlchild: '003'})
        })

      },
      bindGrid() {
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          classcode: this.classcode,
          search: this.searchdata,
          beginDate: this.beginDate,
          endDate: this.endDate
        }).then(response => {
          this.tableData = response.data.obj.rows;
          this.pagination.total = response.data.obj.total;
        }).catch((error) => {
        });

      },
      addInfor() {
        if (this.classcode == "") {
          this.$message({
            type: 'info',
            message: '请选择栏目！'
          });
          return;
        }
        this.$refs.InforEdit.initForm();
        this.$refs.InforEdit.show(this.classcode,this.classname)
      },
      OpenDialog() {//修改
        this.$refs.DataContactEdit.show()
      },
      show(classcode, classname) {
        this.title1 = classname
        this.classname=classname;
        this.searchdata = '';
        this.defaultexpandedkeys = [];
        this.classcode = classcode;
        this.beginDate = '';
        this.endDate = '';
        if (classcode != '')
          this.defaultexpandedkeys.push(classcode);
        this.bindGrid();
        this.dialogFormVisible = true
      },

    },
    mounted() {

    },
    components: {
      InforDetail,
      InforEdit
    }
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/oa/inforclass/InforclassListDialog.vue